module.exports = __webpack_public_path__ + "img/pay (10).9fdd8ddb.png";